export { default } from './UserTemplateHeaderContent'
